// extracted by mini-css-extract-plugin
module.exports = {"root":"NumPad_root__2fAR4","content":"NumPad_content__1YzvH","text":"NumPad_text__1BjFt","num":"NumPad_num__1gQ9Y","mt":"NumPad_mt__37Tqc","mb-8":"NumPad_mb-8__i1N2V"};